import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { MatRippleModule } from '@angular/material/core';
import { TranslateModule } from '@ngx-translate/core';
import { RouterLinkDetectorDirective } from 'app/core/directives/router-link-detector.directive';
import { Link } from 'app/core/models/link.model';
import { AppStoreIcon } from '../../../../assets/icons/app-store/app-store';
import { GooglePlayIcon } from '../../../../assets/icons/google-play/google-play';

@Component({
  selector: 'sheba-app-links',
  templateUrl: 'app-links.component.html',
  standalone: true,
  host: {
    class: 'flex flex-col gap-2'
  },
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [AppStoreIcon, GooglePlayIcon, MatRippleModule, TranslateModule, RouterLinkDetectorDirective]
})
export class ShebaAppLinksComponent {
  googleLink = input.required<Link>();
  appStoreLink = input.required<Link>();
}
